import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarCircleExample = (): React.JSX.Element => {
	return (
		<Avatar
			appearance="circle"
			src="https://pbs.twimg.com/profile_images/803832195970433027/aaoG6PJI_400x400.jpg"
			size="large"
			name="Scott Farquhar"
		/>
	);
};

export default AvatarCircleExample;
